module.exports = __webpack_public_path__ + "static/img/Risk260112TW.56e0013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk260112TW.jpg
// module id = wEmH
// module chunks = 1